import { HeaderLogoProps } from './types';
import { getColorway } from 'utils/styles';
import HeaderLogoItem from './HeaderLogoItem';

const HeaderLogo = ({ sectionName, color, headerLogoItems }: HeaderLogoProps) => {
  return (
    <section {...(sectionName != null && { id: encodeURIComponent(sectionName) })} className={`${getColorway(color)}`}>
      <div className="flex justify-center mx-[56px]">
        <div className="flex my-2 justify-between items-center flex-nowrap">
          {headerLogoItems?.items?.map((item, i) => (
            <HeaderLogoItem
              key={i}
              variant={item.variant}
              image={item.image}
              aspectRatio={item.aspectRatio}
              illustration={item.illustration}
              icon={item.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeaderLogo;
